import {
    IonContent,
    IonPage,
    IonButton,
    useIonViewDidEnter,
} from '@ionic/react'
import { Link } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import './SignIn.css'
import Input from '../components/Input'
import Toast, { ToastProps } from '../components/Toast'
import { signin } from '../service/api/user'
import { useDispatch } from 'react-redux'
import { setUserInfo } from '../redux/actions/user'
import { useHistory } from 'react-router'
import { BotIcon, PassShowIcon, PassHideIcon } from '../conf/images'
import { getKnowledgeTagList } from '../service/api/knowledge'
import { UserModel } from '../model/user.model'
import { HomePage, Reset } from '../conf/routePath'
import { isPhoneNumber, setLocalItem, getLocalItem } from '../utils'

const Logo = () => <img className='logo' src={BotIcon} alt='icon' />
const L_FORM_DATA = 'L_FORM_DATA'
interface FormModel {
    username: string
    password: string
}
interface SiginFormProps {
    value: FormModel
    onChange?: (value: FormModel) => void
}
const SignInForm: React.FC<SiginFormProps> = (props) => {
    const { value, onChange = (value: {}) => undefined } = props
    const [passShow, setPassShow] = useState(false)
    return (
        <div className='signin-form'>
            <Input
                type='number'
                className='input username'
                value={value.username}
                onChange={(val) => {
                    onChange({
                        ...value,
                        username: val.trim(),
                    })
                }}
                placeholder='请输入手机号'
            />
            <Input
                type={passShow ? 'text' : 'password'}
                className='input password'
                value={value.password}
                onChange={(val) =>
                    onChange({
                        ...value,
                        password: val,
                    })
                }
                suffix={
                    <img
                        className='pass-switch'
                        onClick={() => setPassShow(!passShow)}
                        src={passShow ? PassHideIcon : PassShowIcon}
                        alt='icon'
                    />
                }
                placeholder='请输入6-16位密码'
            />
        </div>
    )
}

const SignIn: React.FC = () => {
    const reduxDispatch = useDispatch()
    const history = useHistory()
    const [formdata, setFormdata] = useState<FormModel>(
        getLocalItem(L_FORM_DATA) || {
            username: '',
            password: '',
        }
    )
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        position: 'top',
        color: 'error',
        duration: 1500,
    })
    const [formdataValid, setFormdataValid] = useState(false)
    useIonViewDidEnter(() => {
        reduxDispatch(setUserInfo(null))
    })
    useEffect(() => {
        localStorage.clear()
    }, [])
    useEffect(() => {
        /** 验证表单输入是否有效 */
        const checkFormDataValid = () => {
            let usernameTrim = formdata.username.trim()
            let passwordTrim = formdata.password.trim()
            let valid = !!(usernameTrim && passwordTrim)
            return valid
        }
        setFormdataValid(checkFormDataValid())
        setButtonFlag(checkFormDataValid())
    }, [formdata])

    const [buttonFlag, setButtonFlag] = useState(false)
    /** 登录 */
    const handleSignIn = async () => {
        if (!formdataValid) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                message: '请输入正确的账号和密码.',
            })
            return
        }
        if (!isPhoneNumber(formdata.username)) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '手机号格式不合法',
            })
            return
        }
        setButtonFlag(false)
        try {
            let res = await signin<UserModel>(formdata)
            setButtonFlag(true)
            if (!res) return
            setLocalItem(L_FORM_DATA, {
                username: formdata.username,
                password: '',
            })
            reduxDispatch(setUserInfo(res))
            let tagsRes = await getKnowledgeTagList({
                appHash: res.app_hash,
                tagParent: res.root_tag_id,
            })
            if (tagsRes.data) {
                const custom_tag_id = tagsRes.data.getTagList.filter(
                    (item) => item.ktag_name.indexOf('自定义-') === 0
                )[0].ktag_id
                if (custom_tag_id) {
                    reduxDispatch(
                        setUserInfo({
                            ...res,
                            custom_tag_id: custom_tag_id,
                        })
                    )
                }
            }
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'success',
                message: '登录成功',
            })
            history.replace(HomePage)
            // setTimeout(() => {
            //     history.replace(HomePage)
            // }, 200)
        } catch (error) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: error.message,
            })
            setButtonFlag(true)
        }
    }
    return (
        <IonPage className='signin-page'>
            <IonContent className='content' scrollY={false}>
                <Logo />
                <SignInForm
                    value={formdata}
                    onChange={(val) => {
                        setFormdata(val)
                    }}
                />
                <div className='signin-footer-operate'>
                    <Link to={Reset} className='signin-forget'>
                        忘记密码
                    </Link>
                </div>
                <IonButton
                    disabled={!buttonFlag}
                    color='primary'
                    className='signin-button'
                    onClick={handleSignIn}
                >
                    {formdataValid && !buttonFlag ? 'loading...' : '登录'}
                </IonButton>
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
            </IonContent>
        </IonPage>
    )
}

export default SignIn
